import { PropertyModel } from '@apto/models';
import './property-details-card.scss';
var PropertyDetailsCard = /** @class */ /*@__PURE__*/ (function () {
    function PropertyDetailsCard() {
    }
    return PropertyDetailsCard;
}());
export { PropertyDetailsCard };
